import { render, staticRenderFns } from "./CmgCheckoutOrderDetailsTips.vue?vue&type=template&id=656a36df&scoped=true&lang=pug"
import script from "./cmg-checkout-order-details-tips.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-order-details-tips.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutOrderDetailsTips.vue?vue&type=style&index=0&id=656a36df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a36df",
  null
  
)

export default component.exports